<template>
  <div id="dBConfigurator">
    <db-logo></db-logo>
    <db-stage v-if="$store.state.activePage === 'questionaire'">
      <template v-slot:stage-left>
        <db-progression></db-progression>
      </template>

      <template v-slot:stage-main>
        <db-main-stage-container>
          <db-survey></db-survey>
        </db-main-stage-container>
      </template>
    </db-stage>

    <db-stage v-if="$store.state.activePage === 'start'">
      <template v-slot:stage-main>
        <db-start></db-start>
      </template>
    </db-stage>

    <db-stage v-if="$store.state.activePage === 'productList'">
      <template v-slot:stage-left>
        <db-progression></db-progression>
      </template>
      <template v-slot:stage-main>
        <db-main-stage-container>
          <db-product-list></db-product-list>
        </db-main-stage-container>
      </template>
    </db-stage>

    <db-stage v-if="$store.state.activePage === 'customerForm'">
      <template v-slot:stage-left>
        <db-progression></db-progression>
      </template>
      <template v-slot:stage-main>
        <db-main-stage-container>
          <db-customer-form></db-customer-form>
        </db-main-stage-container>
      </template>
    </db-stage>

    <db-footer></db-footer>
  </div>
</template>

<script>
export default {
  name: "dBConfigurator",
};
</script>
